import { render, staticRenderFns } from "./UserBonusChargeCreate.vue?vue&type=template&id=d65cd38c&scoped=true"
import script from "./UserBonusChargeCreate.vue?vue&type=script&lang=js"
export * from "./UserBonusChargeCreate.vue?vue&type=script&lang=js"
import style0 from "./UserBonusChargeCreate.vue?vue&type=style&index=0&id=d65cd38c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65cd38c",
  null
  
)

export default component.exports